import { ModalDirective } from 'ng2-bootstrap/components/modal';
import { TranslateService } from './../translate/translate.service';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { WeGoConfig } from "../config";
import { AuthService } from '../models/auth.service';
declare var google: any;
declare var H: any;

@Component({
  selector: 'wego-geo-location-map',
  styles: [`
  #map{
    height: 300px;
  }
  `],
  template: `
  <div bsModal #geoLocationModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" 
  aria-labelledby="mySmallModalLabel" aria-hidden="true" [config]="{backdrop: false, keyboard: false}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
            <button type="button" class="close" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{{ popupTitle }}</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                  <label>{{ 'LblEnterLocation' | translate }}</label>
                  <div class="input-group">
                

                    <input id="search-input" placeholder="{{ 'LblEnterLocation' | translate }}" class="form-control" type="text">
                    <div class="input-group-btn">
                        <button class="btn btn-default" type="button" (click)="ResetInput()">
                          <i class="fa fa-eraser" aria-hidden="true"></i>
                        </button>
                    </div>
                  </div>
                  <span id="search-error" class="text text-danger"></span>
                </div>
                <div id="map"></div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-green" (click)="Confirm($event)">{{ 'LblOK' |  translate }}</button>
                <button type="button" class="btn btn-gray" (click)="hide()">{{ 'LblCancel' |  translate }}</button>
            </div>
        </div>
    </div>
  </div>
  `
})
export class GeoLocationMapComponent implements OnInit {
  _popupTitle: string = this.translate.instant('LblSelectGeoLocation');

  @ViewChild('geoLocationModal') public geoLocationModal: ModalDirective;
  _language: string;

  @Input()
  set popupTitle(popupTitle: string) {
    this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblSelectGeoLocation');
  }
  get popupTitle() { return this._popupTitle; }


  @Input()
  set Language(language: string) {
    this._language = language.trim();
  }
  get Language() { return this._language; }

  @Output('onConfirm') onConfirm = new EventEmitter();

  map: any;
  searchBox: any;
  markers: any;
  searchInput: any;
  searchError: any;
  lat: number;
  long: number;
  address: any;
  public platform: any;
  public hgeocoder: any;


  constructor(private translate: TranslateService,
    private authService: AuthService
  ) {
    this.platform = new H.service.Platform({
      'api_key': WeGoConfig.HERE_MAP_API_KEY
    });

    this.platform.setUseHTTPS(true);

    this.hgeocoder = this.platform.getGeocodingService();
  }

  ngOnInit() {
    this.InitDefaultValue();
  }



  public show(address: string, lat: number, long: number) {
    this.geoLocationModal.show();
    let pos: any;
    this.RemoveMarkers();
    this.searchInput.value = "";
    if (address && lat != 0 && long != 0) {
      pos = new google.maps.LatLng(lat, long);
      this.AddMarker(pos);
      this.GeoCodePosition(pos);
    } else {
      //this.UpdateAddress('', 0, 0);      
      pos = new google.maps.LatLng(WeGoConfig.DEFAULT_GEOLOCATION.Lat, WeGoConfig.DEFAULT_GEOLOCATION.Long);
      this.AddMarker(pos);
      this.GeoCodePosition(pos);
    }
    setTimeout(() => {
      let center = pos ? pos : this.map.getCenter();
      google.maps.event.trigger(this.map, "resize");
      this.map.setCenter(center);
    }, 2000);
  }

  public hide() {
    this.geoLocationModal.hide();
  }

  private InitDefaultValue() {
    this.searchInput = document.getElementById('search-input');
    this.searchError = document.getElementById('search-error');
    this.markers = [];
    this.map = new google.maps.Map(document.getElementById('map'), {
      center: { lat: 52.3702164, lng: 4.895168 },
      zoom: 13,
    });

    // Create the search box and link it to the UI element.
    this.searchBox = new google.maps.places.SearchBox(this.searchInput);
    //this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.searchInput);

    // Bias the SearchBox results towards current map's viewport.
    this.map.addListener('bounds_changed', () => this.BoundChange());

    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    this.searchBox.addListener('places_changed', () => this.PlaceChange());
  }

  public RemoveMarkers() {
    while (this.markers.length) {
      this.markers.pop().setMap(null);
    }
  }

  public BoundChange() {
    this.searchBox.setBounds(this.map.getBounds());
  }

  public PlaceChange() {
    this.RemoveMarkers();
    this.searchError.innerHTML = "";
    let places = this.searchBox.getPlaces();
    if (places.length == 0) {
      this.searchError.innerHTML = this.translate.instant('LblAddressNotAvailable');
      this.UpdateAddress('', 0, 0);
      return;
    }

    let place = places[0];
    if (!place.geometry) {
      this.searchError.innerHTML = this.translate.instant('LblAddressNotAvailable');
      this.UpdateAddress('', 0, 0);
      return;
    }
    console.log(place);
    this.AddMarker(place.geometry.location);
    this.UpdateAddress(place.formatted_address, place.geometry.location.lat(), place.geometry.location.lng());
    this.searchInput.value = place.formatted_address;

    let bounds = new google.maps.LatLngBounds();
    if (place.geometry.viewport) {
      // Only geo codes have viewport.
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }
    this.map.fitBounds(bounds);
  }

  public AddMarker(pos: any) {
    // Create a marker for each place.
    let marker = new google.maps.Marker({
      map: this.map,
      //icon: icon,
      //title: place.name,
      position: pos,
      draggable: true,
    });
    this.markers.push(marker);

    marker.addListener('dragend', () => this.GeoCodePosition(marker.getPosition()));
  }

  public GeoCodePosition(pos: any) {
    console.log('GeoCodePosition - reverseGeocode call');
    // let geocoder = new google.maps.Geocoder();
    // geocoder.geocode
    //   ({ latLng: pos },
    //   (results: any, status: any) => {
    //     console.log(results);
    //     console.log(pos);
    //     if (status == google.maps.GeocoderStatus.OK) {
    //       this.searchInput.value = results[0].formatted_address;
    //       this.searchError.innerHTML = "";
    //       this.UpdateAddress(results[0].formatted_address, pos.lat(), pos.lng());
    //     }
    //     else {
    //       this.searchError.innerHTML = this.translate.instant('LblAddressNotAvailable');
    //       this.UpdateAddress('', 0, 0);
    //     }
    //   });

    let userlanguage = 'en';
    if (this.authService.IsDriver()) {
      let usersetting = this.authService.GetUserSetting();
      if (usersetting) {
        userlanguage = usersetting.instanceLanguage
      }
    } else {
      userlanguage = this.Language ? this.Language : 'en';
    }

    this.hgeocoder.reverseGeocode({
      prox: pos.lat() + ',' + pos.lng() + ',' + WeGoConfig.HERE_MAP_LOC_RADIUS, resultType: 'houseNumber',
      query: 'High', language: userlanguage.toLowerCase(), mode: 'retrieveAddress', gen: '9'
    }, (result: any) => {
      if (result.Response.View.length > 0) {
        if (result.Response.View[0].Result.length > 0) {
          console.log(result.Response.View[0].Result);
          let houseMatch = result.Response.View[0].Result.filter((x: any) => x.MatchLevel == 'houseNumber');
          var matchedAddress:any;
          if (houseMatch.length > 0) {
            matchedAddress = houseMatch[0];
          } else {
            matchedAddress = result.Response.View[0].Result[0];
          }

          this.searchInput.value = matchedAddress.Location.Address.Label;
          this.searchError.innerHTML = '';
          this.UpdateAddress(matchedAddress.Location.Address.Label, pos.lat(), pos.lng());

        } else {
          this.searchError.innerHTML = this.translate.instant(
            'LblAddressNotAvailable'
          );
          this.UpdateAddress('', 0, 0);
        }
      } else {
        this.searchError.innerHTML = this.translate.instant(
          'LblAddressNotAvailable'
        );
        this.UpdateAddress('', 0, 0);
      }
    }, (error: any) => {
      console.log(error);
    });


  }

  public UpdateAddress(address: string, lat: number, long: number) {
    this.address = address;
    this.lat = lat;
    this.long = long;
  }

  public Confirm($event: any) {
    this.onConfirm.emit({ address: this.address, lat: this.lat, long: this.long });
    this.hide();
  }

  public ResetInput() {
    this.RemoveMarkers();
    this.searchInput.value = "";
    this.searchError.innerHTML = "";
    this.UpdateAddress('', 0, 0);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/geo-location-map.component.ts